import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {animate, style, transition, trigger} from "@angular/animations";
import {AppDataService} from "../../../../../../core/services/AppDataService";
import {ModelToolsProvider} from "../../../../../../framework/providers/model-tools/model-tools";
import {OrderService} from "../../../../../../core/services/OrderService";
import {Events} from "../../../../../../framework/providers/events";
import {ItemProvider} from "../../../../../../core/pages/item/providers/item-provider/item-provider.service";
import {CatalogAdminService} from "../../../../services/catalogAdminService";

@Component({
    selector: 'app-admin-catalog-admin',
    templateUrl: './catalog-admin-model.component.html',
    styleUrls: ['./catalog-admin-model.component.scss'],
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [ // when created
                style({opacity: 0, transform: 'translateY(10px)'}),
                animate('300ms ease-out', style({opacity: 1, transform: 'translateY(0)'}))
            ]),
            transition(':leave', [ // when removed
                animate('100ms ease-in', style({opacity: 0, transform: 'translateY(-10px)'}))
            ])
        ])
    ]
})
export class CatalogAdminModelComponent implements OnInit, OnDestroy {
    @Input()
    public model: any;
    @Input()
    public checkedData: object;

    //?
    public data: object;

    @Input()
    public filters;
    @Input()
    public sectionId;
    @Input()
    public appDataKey;
    @Input()
    public step = 0;

    public subSections;
    ready = true;
    rows;
    showSubSection;
    items;

    constructor(public appDataService: AppDataService, public itemProvider: ItemProvider,
                public tools: ModelToolsProvider, public events: Events, public catalogAdminService: CatalogAdminService,
                public orderService: OrderService) {
    }

    ngOnInit() {
        // if (!this.data) {
        //     this.data = this.initObject();
        // this.checkedData['sections'] = true;
        // }
        this.update_section_view();
        let me = this;
        // if (this.model) {
        // this.events.subscribe('catalog_refresh', function () {
        //     me.update_section_view();
        // }, '_subi');
        // }
        this.events.subscribe('refresh_section_'+this.sectionId, function () {
            me.update_section_view();
        });
    }

    log(l) {
        console.log(l);
    }

    showSection(model) {
        if (!this.checkedData[model.data.id])
            this.checkedData[model.data.id] = this.initObject(model);

        let me = this;
        this.showSubSection = null;
        // this.data['checkedModel'] = null;
        setTimeout(function () {
            me.showSubSection = model;
            // me.data['checkedModel'] = me.checkedData[model.data.id];
        }, 10);

        // const containerWidth = window.innerWidth; // or viewport width
        // const boxWidth = 100;
        // const boxesPerRow = 3;//Math.floor(containerWidth / boxWidth);
        // this.rows = [];
        // if (this.data['items']) {
        //     for (let i = 0; i < this.data['items'].length; i += boxesPerRow) {
        //         this.rows.push(this.data['items'].slice(i, i + boxesPerRow));
        //     }
        // }
    }

    clickModel(event, model, check = true, open = false) {
        // this.catalogAdminService.current_path_add(model);
        if (check) {
            this.catalogAdminService.markItem('section', model);
        }
        if (open) {
            this.showSection(model);
        }
    }

    clickModelOld(event, model, check = true, open = false) {
        if (model.prefix == 'item') {
            this.itemProvider.openItem(model);
            return;
        }

        if (this.data['checked'] == model.data.id) {
            this.data['checked'] = null;
        }

        if (!this.data['checkedData'][model.data.id])
            this.data['checkedData'][model.data.id] = this.initObject(model);

        this.data['checked'] = model.data.id;
        this.data['checkedModelData'] = model;

        // this.data['checkedData'][model.data.id]['model'] = model
        // this.data['checked'][model.data.id] = !this.data['checked'][model.data.id];
        // this.data['checkedData'][model.data.id]['checkedData']['sections'] = true
    }


    ngOnDestroy() {
        this.events.unsubscribe('refresh_section_' + this.sectionId);

        // if (this.model) {
        this.events.unsubscribe('catalog_refresh', '_subi');
        // }
    }

    setModelData() {
        //data['model']
        let modelId = this.model.data.id;
        // this.sections = this.appDataService.getSectionSubSections(modelId);

        //son items.
        this.items = this.catalogAdminService.getSectionItems({
            'sectionId': modelId,
            'skipSubs': false
        })['direct_models'];
        //  , 'limit':100
    }

    initObject(model = null) {
        return {
            'model': model,
            'models': [],
            'checked': null,
            'checkedData': {
                'sections': true
            }
        }
    }

    update_section_view() {
        if (!this.appDataKey) {
            this.setModelData();
        }
        let subSections;
        if (this.sectionId) {
            subSections = this.catalogAdminService['sections'][this.sectionId]['sections'];
        } else {
            subSections = this.catalogAdminService['topSections'];
        }
        this.subSections = [];
        for (let k of subSections) {
            this.subSections.push(this.catalogAdminService['sections'][k]);
        }

        const boxesPerRow = 5;//Math.floor(containerWidth / boxWidth);
        let me = this;


        me.rows = [];
        if (me.items) {
            for (let i = 0; i < me.items.length + 1; i += boxesPerRow) {
                me.rows.push(me.items.slice(i, i + boxesPerRow));
            }
        }
        this.ready = false;
        setTimeout(function () {
            me.ready = true;
        }, 100);
    }

    openItem() {
        // console.log(this.model)
        // let autoProps = this.model.data.autoProps;
        // this.itemProvider.openItem(this.model, this.cartModel, autoProps, {
        //     'listIndex': this.listIndex,
        //     'listPrefix': this.listPrefix
        // });
        // this.cartModel.data['visible'] = true;
    }



}
